import React, { useEffect, useState } from 'react';
import notificationManager from '../../services/notificationManager';
import Toast from './Toast';

const NotificationContainer = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const unsubscribe = notificationManager?.subscribe((notifications) => {
      setNotifications(notifications);
    });

    return unsubscribe;
  }, []);

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
      {notifications?.map((notification) => (
        <div key={notification?.id} className="pointer-events-auto">
          <Toast
            message={notification?.message}
            type={notification?.type}
            duration={notification?.duration}
            action={notification?.action}
            onClose={() => notificationManager?.remove(notification?.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;